import { Component, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';

@Component({
  selector: 'app-emailtemplates',
  templateUrl: './emailtemplates.component.html',
  styleUrls: ['./emailtemplates.component.css'],
  providers: [Modal]
})
export class EmailtemplatesComponent implements OnInit {
  public emailTemplate: any={};
  busy: Subscription;
  public data;
  public dataNotFound: string;
  public filterQuery = "";
  public rowsOnPage = 10;
  public sortBy = "updated_at";
  public sortOrder = "desc";
  
  public token: string;
  
  constructor(private router: Router, vcRef: ViewContainerRef,private renderer : Renderer2, public modal: Modal, private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 

	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;

	}

  ngOnInit() {
	this.getAllEmailTemplate();
  }
  
  // list all template
  
  getAllEmailTemplate(){
		
	  var data = {
			token :this.token
		}
		let responseData = <any>{};
		
		this.busy = this.echexpaymentService.getAllEmailTemplate(data).subscribe(
			response => {
				responseData = response;
				this.data = responseData.data;
				if(this.data.length == 0){
					 this.dataNotFound =  responseData.message
				}
			},
			error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			}
		);
	
    }
    
	// delete template by _id
	
	deleteTemplate(event,tem_id){
		event.stopPropagation();
		this.modal.confirm()
		.size('sm')
		.title('CasherPay')
		.body(`Are you sure to delete this template. ` )
		.okBtn('Okay')
		.cancelBtn('Cancel')
		.okBtnClass('btn btn-success')
		.cancelBtnClass('btn btn-warning')
		.open()
		.then( (resultPromise) => {
		  resultPromise.result.then( (result) => {
			var data = {
			  token:this.token,
			  template_id:tem_id
			}
		  let responseData = <any>{};	
		  this.busy = this.echexpaymentService.deleteTemplate(data).subscribe(
			   response => {
				responseData = response;
				this.toastr.success(responseData.message, 'Success!');
				this.getAllEmailTemplate();
			   },
			   error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			   }
		  );
		}, 
		() => {
		 console.log('Cancel');
		} );
		});
	}
	
    ngAfterViewInit(){
		this.renderer.selectRootElement('#initialFocus').focus();
	}
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/emailtemplates/emailtemplates.component.ts